/**
 * Group Recruiting Meeting — start-time formatting.
 *
 * Formats an ISO-UTC instant (e.g. "2026-07-22T23:00:00Z") as a friendly start
 * time in the VIEWER's own (browser) timezone — e.g. "Wednesday at 7:00 PM EDT".
 * Returns null for missing/invalid input so callers can branch cleanly.
 */
export default function formatMeetingStartLocal(iso) {
  if (!iso) return null
  const d = new Date(iso)
  if (isNaN(d.getTime())) return null
  try {
    return d.toLocaleString(undefined, {
      weekday: 'long',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    })
  } catch (e) {
    return d.toLocaleString()
  }
}
